/* FNDMNTLS CRO — P5 (Scarcity) + P9 (Size Guide Link) */
(function() {
  var THRESHOLD = 5;
  var SIZE_GUIDE_URL = '/pages/fndmntls-size-guide-streetwear-fit';

  /* ── P9: Inject SIZE GUIDE link next to size selector ─── */
  function injectSizeGuideLinks() {
    document.querySelectorAll('.fndmntls-size-guide-note').forEach(function(el) {
      if (el.querySelector('.fndmntls-size-guide-link')) return;
      el.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:8px';
      var link = document.createElement('a');
      link.className = 'fndmntls-size-guide-link';
      link.href = SIZE_GUIDE_URL;
      link.textContent = 'SIZE GUIDE \u2192';
      link.style.cssText = 'font-size:10px;letter-spacing:1.5px;color:#84A4EA;text-decoration:underline;font-weight:600;white-space:nowrap;flex-shrink:0';
      el.appendChild(link);
    });
  }

  /* ── P5: Scarcity signal above CTA ───────────────────── */
  function ensureScarcityEl() {
    var existing = document.querySelector('.add-to-cart .fndmntls-scarcity');
    if (existing) return existing;
    var navBtn = document.querySelector('.add-to-cart .navigation-buttons');
    if (!navBtn) return null;
    var div = document.createElement('div');
    div.className = 'fndmntls-scarcity';
    div.style.cssText = 'display:none;font-size:11px;letter-spacing:1px;color:#c0392b;font-weight:600;margin:0 0 8px';
    navBtn.parentNode.insertBefore(div, navBtn);
    return div;
  }

  function showScarcity(qty) {
    var el = ensureScarcityEl();
    if (!el) return;
    if (qty > 0 && qty <= THRESHOLD) {
      el.textContent = 'Only ' + qty + ' left \u2014 order soon';
      el.style.display = 'block';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function fetchInventory(variantId) {
    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('/')[0];
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var variant = null;
        if (variantId) variant = p.variants.find(function(v) { return v.id === variantId; });
        if (!variant) variant = p.variants[0];
        if (variant && typeof variant.inventory_quantity !== 'undefined') {
          showScarcity(variant.inventory_quantity);
        }
      }).catch(function() {});
  }

  function getSelectedVariantId() {
    var idInput = document.querySelector('.add-to-cart .product-form input[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function init() {
    injectSizeGuideLinks();
    ensureScarcityEl();
    fetchInventory(getSelectedVariantId());

    document.addEventListener('change', function(e) {
      if (!e.target) return;
      if (e.target.name === 'id' || e.target.classList.contains('variant-input')) {
        setTimeout(function() { fetchInventory(getSelectedVariantId()); }, 300);
      }
    });

    document.addEventListener('variant:changed', function(e) {
      var v = e.detail && e.detail.variant;
      if (v && typeof v.inventory_quantity !== 'undefined') showScarcity(v.inventory_quantity);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
